// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8b788a5b","396":"07a5632b","455":"3b04b206","977":"95ca25a6"}[chunkId] + ".chunk.js";
};